import { render } from "./SlideShow.vue?vue&type=template&id=68be97e7"
import script from "./SlideShow.vue?vue&type=script&lang=js"
export * from "./SlideShow.vue?vue&type=script&lang=js"

import "./SlideShow.vue?vue&type=style&index=0&id=68be97e7&lang=scss"

import exportComponent from "/codebuild/output/src1968952969/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__